import { UserData } from "client/store"
import { OnlineUsers } from "client/utils"

import { clientSocket } from "client/socketApi"
import {
    SOCKET_GET_SERVER_USER_DATA,
    SOCKET_SET_SERVER_USER_DATA,
    SOCKET_UPDATE_SERVER_USER_DATA,
    SOCKET_CLEAR_SERVER_USER_DATA,
    SOCKET_SET_CLIENT_USER_DATA,
    SOCKET_CLEAR_CLIENT_USER_DATA,
    SOCKET_SEND_ONLINE_USERS,
} from "const"


// emitters
export const setServerUserData = (userData: UserData) => {
    clientSocket.emit(SOCKET_SET_SERVER_USER_DATA, userData)
}
export const updateServerUserData = (userData: UserData) => {
    clientSocket.emit(SOCKET_UPDATE_SERVER_USER_DATA, userData)
}
export const getServerUserData = (userId: number, sessionId: string, callback: (userData: UserData) => void) => {
    clientSocket.emit(SOCKET_GET_SERVER_USER_DATA, userId, sessionId, callback)
}
export const clearServerUserData = (userId: number, sessionId: string) => {
    clientSocket.emit(SOCKET_CLEAR_SERVER_USER_DATA, userId, sessionId)
}


// listeners
export const listenSocketSetUserData = (callback: (userData: UserData) => void) => {
    clientSocket.on(SOCKET_SET_CLIENT_USER_DATA, callback)
}
export const listenSocketClearUserData = (callback: () => void) => {
    clientSocket.on(SOCKET_CLEAR_CLIENT_USER_DATA, callback)
}
export const listenSocketOnlineUsers = (callback: (onlineUsers: OnlineUsers) => void) => {
    clientSocket.on(SOCKET_SEND_ONLINE_USERS, callback)
}
